import { Centered } from './NotFound.jsx';

export function Expired() {
  return (
    <Centered title="This link has expired">
      <p>Your Fundmerica application link is no longer valid.</p>
      <p>Please contact your representative to receive a new link.</p>
    </Centered>
  );
}
